{
  "slug": "what-does-an-iq-of-120-mean",
  "title": "What does an IQ of 120 mean?",
  "description": "Learn how an IQ score of 120 compares with the average, its approximate percentile, and what it can and cannot predict.",
  "summary": "On a common IQ scale, 120 is about 1.33 standard deviations above the mean and near the 91st percentile.",
  "sections": [
    {
      "heading": "Understanding the percentile",
      "paragraphs": [
        "An approximate 91st percentile means measured performance was as high as or higher than that of about 91% of the relevant norm group. It does not mean 91% of items were correct.",
        "The exact percentile varies slightly by test, age band, and norm table. The report’s own conversion table should take priority."
      ]
    },
    {
      "heading": "Likely interpretation",
      "paragraphs": [
        "A score of 120 is commonly described as above average or high average. It may reflect strong performance in the reasoning, learning, or problem-solving skills sampled.",
        "The overall score can conceal uneven abilities. Verbal, visual, memory, and speed indexes offer a fuller picture in a comprehensive battery."
      ]
    },
    {
      "heading": "What the score cannot guarantee",
      "paragraphs": [
        "An IQ of 120 does not guarantee academic success, career performance, creativity, emotional maturity, or good decisions. Opportunity, effort, health, interests, and personality remain important.",
        "Because every score has a margin of error, 120 is better viewed as a range around an estimate than an exact lifelong value."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Is 120 a high IQ?",
      "answer": "It is clearly above the mean on a scale centered at 100 and is near the 91st percentile."
    },
    {
      "question": "Can a score of 120 change?",
      "answer": "Yes. Retesting, development, health, practice, and measurement error can produce a different result."
    }
  ],
  "related": ["iq-score-ranges-explained", "can-iq-change-over-time", "what-does-an-iq-of-140-mean"]
}
